module.exports = __webpack_public_path__ + "static/media/john-team-img-370x370.bc2c1065.jpg";